<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-row class="d-flex flex-column" align="center" justify="start">
          <Logo height="25vh" />
          <v-card flat min-width="65vw" height="40vh" class="mb-12">
            <v-stepper v-model="currentStep.index" alt-labels class="elevation-0">
              <v-stepper-header
                class="no-shadow d-none d-md-flex d-lg-flex d-xl-flex"
                style="margin-bottom "
              >
                <v-stepper-step
                  class
                  v-for="(iteratedStep, i) in steps"
                  :key="i"
                  :complete="currentStep.index > i"
                  :step="i + 1"
                >{{ $t(steps[i].label) }}</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content v-for="(iteratedStep, i) in steps" :key="i" :step="i + 1">
                  <v-card flat min-width="40vw">
                    <div class="title mx-4">{{ currentStep.title ? $t(currentStep.title) : "" }}</div>
                    <div>
                      <v-card-text v-if="currentStep.label === 'Sign up'">
                        <v-text-field
                          :label="$t('Establishent name')"
                          outlined
                          flat
                          dense
                          name="name"
                          v-model="name"
                          :rules="[validateName]"
                          :error-messages="errors.name"
                          prepend-inner-icon="mdi-silverware-variant"
                          type="text"
                          @keydown.enter="tryMoveOn"
                        />
                        <v-text-field
                          :label="$t('email')"
                          outlined
                          flat
                          dense
                          name="email"
                          v-model="email"
                          prepend-inner-icon="mdi-email-outline"
                          :rules="[validateEmail]"
                          :error-messages="$t(errors.email)"
                          type="text"
                          @keydown.enter="tryMoveOn"
                        />
                        <v-text-field
                          :label="$t('Password')"
                          outlined
                          flat
                          dense
                          name="password"
                          v-model="password"
                          prepend-inner-icon="mdi-lock-outline"
                          :rules="[validatePassword]"
                          :error-messages="$t(errors.password)"
                          type="password"
                          @keydown.enter="tryMoveOn"
                        />
                        <v-text-field
                          :label="$t('Confirm password')"
                          outlined
                          flat
                          dense
                          name="confirmPassword"
                          v-model="confirmPassword"
                          prepend-inner-icon="mdi-lock-outline"
                          :rules="[validateConfirmPassword]"
                          :error-messages="$t(errors.confirmPassword)"
                          type="password"
                          @keydown.enter="tryMoveOn"
                        />
                        <div class="d-flex flex-column align-center text-center">
                          <v-checkbox v-model="isOkWithSpam" dense>
                            <template v-slot:label>
                              <div class="caption">
                                {{
                                $t(
                                "Receive email about your MerloCode activity, recommendations and news"
                                )
                                }}.
                              </div>
                            </template>
                          </v-checkbox>

                          <div class="mt-2">
                            <span>{{ $t("By signing up you agree to our") + " " }}</span>
                            <a href="https://merlocode.com/legal">
                              {{
                              $t(
                              "Terms of Service, Privacy Policy and Cookie Use"
                              )
                              }}
                            </a>
                            <span>
                              {{
                              $t(
                              ". You also agree that you're over 16 years old."
                              )
                              }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                      <v-card-title v-if="currentStep.label === 'Verify email'" class="mb-2">
                        <div class="d-flex flex-column">
                          <div>{{ $t("We sent you a verification email") }}</div>
                          <div v-if="emailVerificationTimeOut" class="body-2">
                            {{
                            $t(
                            "This is taking a while. Please reload after verifying your email."
                            )
                            }}
                          </div>
                          <a
                            class="caption"
                            @click="resendVerificationEmail"
                          >{{ $t("Didn't receive email? Resend") }}</a>
                        </div>
                      </v-card-title>
                      <v-row
                        v-if="currentStep.label === 'Establishment image'"
                        align="start"
                        style="margin-right: 0px;  margin-left: 0px;"
                        justify="space-between"
                      >
                        <v-col class="mr-4">
                          <div class="body-1">
                            <div>
                              {{
                              $t(
                              "This is just a preview of what your customers will see when opening MerloCode in your establishent."
                              )
                              }}
                            </div>
                            <br />
                            <div>
                              {{
                              $t(
                              "You can set up your banner, your logo, only one of them or none at all."
                              )
                              }}
                            </div>
                          </div>
                          <v-file-input
                            v-model="banner"
                            prepend-icon="mdi-camera"
                            name="banner"
                            @change="file => previewImage('banner', file)"
                            :label="$t('Banner')"
                            accept="image/png, image/jpeg, image/gif"
                          />

                          <v-file-input
                            v-model="logo"
                            prepend-icon="mdi-camera"
                            name="logo"
                            @change="file => previewImage('logo', file)"
                            :label="$t('Logo')"
                            accept="image/png, image/jpeg, image/gif"
                          />
                        </v-col>
                        <v-col class="my-2 ml-4">
                          <MobileIphone :sizeFactor="0.48">
                            <PreviewMenu
                              class="content"
                              :color="
                                  isDark ? primaryColorDark : primaryColorLight
                                "
                              :isDark="isDark"
                              :images="images"
                              :waiter="true"
                            />
                          </MobileIphone>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="currentStep.label === 'Establishment colours'"
                        align="start"
                        style="margin-right: 0px;  margin-left: 0px;"
                        justify="center"
                      >
                        <v-col class="mr-4">
                          <v-row align="start" justify="space-between">
                            <v-col>
                              <v-row align="center" justify="space-between">
                                <v-col cols="1">
                                  <a @click="isDark = !isDark">
                                    <v-icon v-if="isDark">mdi-brightness-4</v-icon>
                                    <v-icon v-else>mdi-brightness-7</v-icon>
                                  </a>
                                </v-col>
                                <v-col>
                                  <v-color-picker
                                    v-if="!isDark"
                                    v-model="primaryColorLight"
                                    canvas-height="80px"
                                    flat
                                    hide-inputs
                                  />
                                  <v-color-picker
                                    v-else
                                    v-model="primaryColorDark"
                                    canvas-height="80px"
                                    flat
                                    hide-inputs
                                  />
                                </v-col>
                              </v-row>
                              <div class="body-1">
                                {{
                                $t(
                                "You can set the primary colour that your menu will display for both dark and light mode."
                                )
                                }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col class="my-2 ml-4">
                          <MobileIphone :sizeFactor="0.48">
                            <PreviewMenu
                              class="content"
                              :color="
                                  isDark ? primaryColorDark : primaryColorLight
                                "
                              :isDark="isDark"
                              :images="images"
                              :waiter="true"
                            />
                          </MobileIphone>
                        </v-col>
                      </v-row>
                      <v-row
                        style="margin-right: 0px;  margin-left: 0px;"
                        v-if="currentStep.label === 'Your plan'"
                        align="start"
                        justify="center"
                      >
                        <ProductPlans />
                      </v-row>
                    </div>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
              <v-row class="mx-2">
                <v-btn
                  v-if="!!currentStep.previousButton"
                  color="primary"
                  outlined
                  large
                  class="px-8"
                  @click="currentStep.previousButton.action"
                >{{ $t("Back") }}</v-btn>
                <v-spacer />

                <v-btn
                  v-if="!!currentStep.nextButton"
                  :disabled="loading"
                  color="primary"
                  outlined
                  @click="tryMoveOn"
                >
                  <div v-if="loading">
                    <v-progress-circular indeterminate size="26" color="primary" class="mr-4"></v-progress-circular>
                  </div>
                  {{ $t(currentStep.nextButton.label) }}
                </v-btn>
              </v-row>
            </v-stepper>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
    <LoadingSpinner />
  </v-app>
</template>

<script>
import LoadingSpinner from "@/views/dashboard/components/LoadingSpinner";

import ProductPlans from "@/views/dashboard/components/stripe/ProductPlans";
import AuthService from "@/service/auth_service";
import Restaurant from "@/model/restaurant";
import PreviewMenu from "@/views/dashboard/components/PreviewMenu";
import MobileIphone from "@/views/dashboard/components/MobileIphone";
import Logo from "@/views/dashboard/components/Logo";
import { storage } from "@/firebase/firestore.js";

export default {
  components: { Logo, PreviewMenu, MobileIphone, ProductPlans, LoadingSpinner },
  data() {
    return {
      steps: [
        {
          index: 1,
          label: "Sign up",
          title: "Create your MerloCode account",
          isValid: this.validateSignUp,
          nextButton: { label: "Sign up", action: this.startSignUpProcess }
        },
        {
          index: 2,
          label: "Verify email",
          nextButton: { label: "Next", action: this.nextConfigStep }
        },
        {
          index: 3,
          label: "Establishment image",
          title: "Set up your establishment image",
          nextButton: { label: "Next", action: this.nextConfigStep }
        },
        {
          index: 4,
          label: "Establishment colours",
          title: "Set up your establishment colours",
          nextButton: {
            label: "Your plan",
            action: this.finishConfig
          }
          // previousButton: {
          //   label: "Back",
          //   action: this.previousConfigStep
          // }
        },
        {
          index: 5,
          label: "Your plan",
          title: this.$t("Choose your plan")
        }
      ],
      emailVerified: false,
      isSignedIn: false,
      email: "",
      name: "",
      password: "",
      confirmPassword: "",
      isOkWithSpam: false,
      errors: {},
      isDark: false,
      primaryColorLight: this.$vuetify.theme.themes.light.primary,
      primaryColorDark: this.$vuetify.theme.themes.dark.primary,
      startStep: null,
      banner: null,
      logo: null,
      preview: {},
      loading: false
    };
  },

  computed: {
    currentStep() {
      // Sign up is done if user is signed in and has a restaurant associated
      if (!(this.isSignedIn && this.$store.getters.restaurant)) {
        return this.steps[0];
      }
      let step = this.$store.getters.restaurant.startStep;
      if (!this.emailVerified) {
        return this.steps[1];
      } else {
        step++;
      }

      if (step < this.steps.length) {
        return this.steps[step];
      }
      if (!this.$store.getters.accountType) {
        return this.steps[5];
      }
      this.goTo("/");
      return this.steps[this.steps.length - 1];
    },

    emailVerificationTimeOut() {
      return this.errors.emailVerified;
    },

    isFirstStep() {
      return this.step === 1;
    },

    isLastStep() {
      return this.step === this.totalSteps;
    },

    totalSteps() {
      return this.steps.length;
    },

    images() {
      let restaurant = this.$store.getters.restaurant;
      let banner = this.preview.banner
        ? this.preview.banner
        : restaurant.banner;
      let logo = this.preview.logo ? this.preview.logo : restaurant.logo;
      return { logo: logo, banner: banner };
    }
  },

  watch: {
    name() {
      this.errors.name = null;
    },
    email() {
      this.errors.email = null;
    },
    password() {
      this.errors.password = null;
    },
    confirmPassword() {
      this.errors.confirmPassword = null;
    }
  },

  methods: {
    goTo(page) {
      this.$router.replace(`/${page}`);
    },

    // Inner logic
    async tryMoveOn() {
      this.loading = true;
      if (
        this.currentStep.isValid === undefined ||
        this.currentStep.isValid()
      ) {
        if (this.currentStep.nextButton) {
          await this.currentStep.nextButton.action();
        }
      }
      this.loading = false;
    },

    handleVerificationCallback() {
      this.emailVerified = true;
    },

    // External logic
    async startSignUpProcess() {
      try {
        if (!AuthService.info.id) {
          this.startStep = 1;
          this.$gtag.event("new_client", {
            restaurantName: this.name,
            user: this.email
          });
          await AuthService.signUp(
            this.email,
            this.password,
            new Restaurant({
              name: this.name,
              mailSubscription: this.isOkWithSpam,
              startStep: 1
            }),

            this.handleVerificationCallback
          );
        }
      } catch (error) {
        switch (error.message) {
          case "email-already-in-use":
          case "invalid-email":
            this.errors.email = error.message;
            break;
          case "operation-not-allowed":
            break;
          case "weak-password":
            this.errors.password = error.message;
            break;
        }
        this.errors = { ...this.errors };
        return false;
      }
      return true;
    },

    async saveImageIfAny(name, preview, restaurant) {
      if (preview[name]) {
        try {
          let imgRef = storage.child(`${restaurant.id}/${name}`);
          let snapshot = await imgRef.putString(
            this.preview[name].split(",")[1],
            "base64"
          );
          let downloadURL = await snapshot.ref.getDownloadURL();
          restaurant[name] = downloadURL;
        } catch (error) {
          switch (error.code) {
            case "storage/unauthorized":
              // TODO Handle error
              // alert("unauthorized");
              break;
            case "storage/canceled":
              // alert("canceled");
              break;
            case "storage/unknown":
              // alert("unknown");
              break;
            default:
            // alert(error.code);
          }
        }
        return true;
      }
      return false;
    },

    async nextConfigStep() {
      let restaurant = this.$store.getters.restaurant;
      let existChanges = false;
      if (!this.startStep || restaurant.startStep === this.startStep) {
        existChanges = true;
        restaurant.startStep += 1;
      }

      existChanges =
        (await this.saveImageIfAny("banner", this.preview, restaurant)) ||
        existChanges;
      existChanges =
        (await this.saveImageIfAny("logo", this.preview, restaurant)) ||
        existChanges;

      if (existChanges) {
        if (!AuthService.emailVerified) {
          restaurant.startStep = 1;
        }
        restaurant.save();
        this.preview = {};
      }
      this.startStep = this.startStep
        ? this.startStep + 1
        : restaurant.startStep;
    },

    previousConfigStep() {
      if (!this.startStep) {
        this.startStep = this.$store.getters.restaurant.startStep;
      }
      this.startStep--;
    },

    async finishConfig() {
      let restaurant = this.$store.getters.restaurant;
      let save = false;
      if (!this.isLastStep) {
        restaurant.startStep += 1;
        save = true;
      }

      if (!restaurant.colors) {
        restaurant.colros = {
          light: this.primaryColorLight,
          dark: this.primaryColorDark
        };
        save = true;
      } else {
        if (this.primaryColorLight !== restaurant.colors.light) {
          restaurant.colors.light = this.primaryColorLight;
          save = true;
        }
        if (this.primaryColorDark !== restaurant.colors.dark) {
          restaurant.colors.dark = this.primaryColorDark;
          save = true;
        }
      }
      if (save) {
        restaurant.save();
      }
      // this.goTo("/orders"); // TODO First page: Settings, orders or products?
    },

    resendVerificationEmail() {
      AuthService.sendVerificationEmail();
    },

    // Validations
    validatePassword() {
      return this.password && this.password.length > 6
        ? true
        : "Password should contain at least 6 characters";
    },

    validateConfirmPassword() {
      return this.confirmPassword && this.confirmPassword === this.password
        ? true
        : "Your passwords do not match";
    },

    validateName() {
      return this.name ? true : "This field is required";
    },

    validateEmail() {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(this.email) ? true : "Please enter a valid email";
    },

    validateSignUp() {
      if (AuthService.isSignedIn) return true;

      let validations = {
        name: this.validateName,
        email: this.validateEmail,
        password: this.validatePassword,
        confirmPassword: this.validateConfirmPassword
      };
      let success = true;
      for (let field in validations) {
        let error = validations[field]();
        if (error !== true) {
          success = false;
          this.errors[field] = error;
          this.errors = { ...this.errors };
        }
      }
      return success;
    },

    previewImage(fileName, file) {
      var reader = new FileReader();
      reader.onload = e => {
        this.preview = { ...this.preview };
        this.preview[fileName] = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  },

  mounted() {
    AuthService.onAuthStateChanged(user => {
      if (user) {
        this.isSignedIn = true;
        this.emailVerified = user.emailVerified;

        let restaurant = this.$store.getters.restaurant;
        if (restaurant && restaurant.colors) {
          if (restaurant.colors.light) {
            this.primaryColorLight = restaurant.colors.light;
          }
          if (restaurant.colors.dark) {
            this.primaryColorDark = restaurant.colors.dark;
          }
        }
      }
    });
  }
};
</script>

<style scoped>
.no-shadow {
  box-shadow: none !important;
}
.v-row {
  margin-right: 0px;
  margin-left: 0px;
}
</style>
